import {cashBoxHeaderFilter} from "../../../hoc/cashBoxHeaderFilter";
import CashBoxCashOutRegister from "./CashBoxCashOutRegister";

const CashBoxCashOutDataTableHeader = cashBoxHeaderFilter(CashBoxCashOutRegister, "CashBoxCashOutDataTableHeader")

export default CashBoxCashOutDataTableHeader
